module.exports = __webpack_public_path__ + "static/img/cab-dualmic.3cc8aa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/amp/cab-dualmic.png
// module id = EleD
// module chunks = 12